<template>
    <nav id="sidebar">
        <div class="sidebar-header">
            <h3>Academic Dean's Office</h3>
        </div>
        <div id="ado-admin__nav">
            <nav class="nav flex-column">
                <router-link :to="navItems.dashboard.path" class="nav-link"><i :class="navItems.dashboard.icon"></i>
                    {{ navItems.dashboard.title }}</router-link>
                <router-link :to="navItems.assignments.path" class="nav-link"><i :class="navItems.assignments.icon"></i>
                    {{ navItems.assignments.title }}</router-link>
                <router-link v-if="checkPermission(navItems.export.key)" :to="navItems.export.path"
                    class="nav-link"><i :class="navItems.export.icon"></i> {{ navItems.export.title }}</router-link>
                <router-link :to="navItems.history.path" class="nav-link"><i :class="navItems.history.icon"></i>
                    {{ navItems.history.title }}
                </router-link>
                <router-link :to="navItems.summary.path" class="nav-link"><i :class="navItems.summary.icon"></i>
                    {{ navItems.summary.title }}
                </router-link>
                <!-- Settings -->
                <div class="accordion" id="accordionExample">
                    <button class="btn nav-link collapsed" type="button" data-toggle="collapse"
                        data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <i :class="navItems.settings.icon"></i>
                        {{ navItems.settings.title }}
                    </button>
                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                        <div class="card-body pt-0 pb-0">
                            <router-link :to="navItems.checkinoptions.path" class="nav-link nav-link__small">
                                {{ navItems.checkinoptions.title }}</router-link>
                            <router-link :to="navItems.counsellors.path" class="nav-link nav-link__small">
                                {{ navItems.counsellors.title }}</router-link>
                            <router-link :to="navItems.notifications.path" class="nav-link nav-link__small">
                                {{ navItems.notifications.title }}</router-link>
                            <router-link :to="navItems.waitingareas.path" class="nav-link nav-link__small">
                                {{ navItems.waitingareas.title }}</router-link>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </nav>
</template>

<script>
import auth from '../../js/auth';

export default {
    name: 'ado-admin-sidebar',
    data() {
        return {
            navItems: {
                assignments: {
                    icon: 'far fa-clipboard-list-check',
                    key: 'assignments',
                    path: '/ado/admin/assignment',
                    title: 'Assignments'
                },
                checkinoptions: {
                    icon: '',
                    key: 'settings-checkin-options',
                    path: '/ado/admin/settings/checkin-options',
                    title: 'Check-in Options'
                },
                counsellors: {
                    icon: '',
                    key: 'settings-counsellors',
                    path: '/ado/admin/settings/counsellors',
                    title: 'Counsellors'
                },
                dashboard: {
                    icon: 'far fa-home',
                    key: 'dashboard',
                    path: '/ado/admin',
                    title: 'Dashboard'
                },
                export: {
                    icon: 'far fa-file-export',
                    key: 'export',
                    path: '/ado/admin/export',
                    title: 'Export'
                },
                history: {
                    icon: 'far fa-history',
                    key: 'history',
                    path: '/ado/admin/history',
                    title: 'History'
                },
                notifications: {
                    icon: '',
                    key: 'settings-notifications',
                    path: '/ado/admin/settings/notifications',
                    title: 'Notifications'
                },
                summary: {
                    icon: 'far fa-analytics',
                    key: 'summary',
                    path: '/ado/admin/summary',
                    title: 'Summary'
                },
                settings: {
                    icon: 'far fa-cog',
                    key: 'settings',
                    path: '/ado/admin/settings',
                    title: 'Settings'
                },
                waitingareas: {
                    icon: '',
                    key: 'settings-waiting-areas',
                    path: '/ado/admin/settings/waiting-areas',
                    title: 'Waiting Areas'
                }
            }
        }
    },
    methods: {
        checkPermission(key) {
            let permissions = auth.getPermissions();

            if ((permissions.all && permissions.all.enabled == 1) || (permissions.export && permissions.export.enabled == 1)) {
                return true;
            }

            return false;
        }
    }
}
</script>

<style scoped>
.nav-link {
    padding: .75rem 40px;
    margin: .25rem 0;
    color: #9899ac;
    background: transparent;
    text-align: left;
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
    width: 100%;
}

.nav-link i {
    font-size: 1.25rem;
}

.nav-link:hover {
    color: #5d78ff;
}

.nav-link__small {
    font-size: 14px !important;
}

.nav-link__small i {
    font-size: 14px !important;
}

.router-link-exact-active {
    background-color: #f5f6fc;
    color: #5d78ff;
    font-weight: 600;
}

#sidebar {
    width: 250px;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 999;
    background: #fff;
    transition: all 0.3s;
    -webkit-box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.08);
    box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.08);
}

#sidebar.active {
    margin-left: -250px;
}

#sidebar .sidebar-header {
    padding: 2rem 1rem;
    background: #1a1a27;
    color: #fff;
    margin-bottom: 32px;
}

.sidebar__menu-header {
    font-size: 12px;
    margin-bottom: 0px;
    padding: 14px 20px;
    color: #99abb4;
    font-weight: 600;
    text-transform: uppercase;
}

#sidebar ul.components {
    padding: 20px 0;
}

#sidebar ul li a {
    cursor: pointer;
    padding: 0px 10px;
    display: block;
    margin: 15px 10px;
    color: #607d8b;
    display: block;
    font-size: 16px;
    border-radius: 4px;
    white-space: nowrap;
    -webkit-transition: all .2s ease-out;
    -moz-transition: all .2s ease-out;
    -o-transition: all .2s ease-out;
    -ms-transition: all .2s ease-out;
    transition: all .2s ease-out;
}

#sidebar ul li a:hover {
    color: #4169e1;
    text-decoration: none;
}

#sidebar ul li.active>a,
a[aria-expanded="true"] {
    color: #fff;
    background: #4169e1;
}

a[data-toggle="collapse"] {
    position: relative;
}

.sidebar__active {
    color: #ffffff !important;
    background: #4169e1 !important;
    font-weight: 500 !important;
    -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 8px 35px 8px 15px !important;
    border-radius: 4px !important;
}

.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
}

@media (max-width: 768px) {
    #sidebar {
        margin-left: -250px;
    }

    #sidebar.active {
        margin-left: 0;
    }

    #sidebarCollapse span {
        display: none;
    }
}
</style>